var fr_CH = {};
module['exports'] = fr_CH;
fr_CH.title = "French (Switzerland)";
fr_CH.address = require("./address");
fr_CH.internet = require("./internet");
fr_CH.phone_number = require("./phone_number");
